import React from 'react';
import DelimitedLabels from '../../common/components/DelimitedLabels';
import TagsPreview from '../../common/components/TagsPreview';
import { INFO_TILES } from '../../common/constants/constants';
import { useIsWithinBreakpoints } from '../../common/hooks/useIsWithinBreakpoints';
import { H, V } from '../../common/Layout';
import { useDataListCell } from '../DataList/DataListCellContext';
import ProductionDetailsSection from '../DataList/ProductionDetailsSection';
import type { ProductionTypeSuperset } from '../helpers/productionApi';
import HeaderLabel from './HeaderLabel';
import LocationsLabel from './LocationsLabel';
import { ProductionStatusChips } from './ProductionStatusChips';

type ProductionOverviewDataGridProps = {
    viewState: ProductionTypeSuperset;
    showOpenInNewTabLink?: boolean;
    sidePanelView?: boolean;
};

export default function ProductionOverviewDataGrid({
    viewState,
    showOpenInNewTabLink,
    sidePanelView
}: ProductionOverviewDataGridProps) {
    const isSmallDevice = useIsWithinBreakpoints(['xs', 's']);
    const { isNotesPanelOpen } = useDataListCell();
    const { ownerOrganizationName, productionType, genre } = viewState;

    const infoTiles = [
        { key: INFO_TILES.ownerOrganizationName, text: ownerOrganizationName },
        { key: INFO_TILES.productionType, text: productionType },
        { key: INFO_TILES.genre, text: genre }
    ]
        .filter((tile) => Boolean(tile.text))
        .map((tile) => <HeaderLabel key={tile.key} text={tile.text!} />);

    return (
        <V gap={1}>
            <ProductionDetailsSection
                name={viewState.name}
                id={viewState.id ?? viewState.identity.id}
                createdFrom={viewState.createdFrom}
                otherTitles={viewState.otherTitles}
                showOpenInNewTabLink={showOpenInNewTabLink || sidePanelView}
                productionType={viewState}
            />
            {(isSmallDevice || isNotesPanelOpen) && (
                <ProductionStatusChips
                    productionStatus={viewState?.productionStatus}
                    projectStatus={viewState?.projectStatus}
                />
            )}
            <LocationsLabel locations={viewState?.locations} />
            <TagsPreview tags={viewState.tags} sx={{ width: { xs: 'calc(100vw - 80px)', sm: 420, md: '100%' } }} />
            <H sx={{ gap: 0.5, paddingBottom: 0.5 }}>
                <DelimitedLabels>{infoTiles}</DelimitedLabels>
            </H>
        </V>
    );
}
